import Vue from "vue";
import eventBus from "@/utils/EventBus";
import * as iotServicesSdk from "iot-services-sdk";

const state = {
  metadata: null,
  devices: [],
  perimeters: [],
  firmwares: [],
  neuralNetworkFirmwares: [],
  neuralNetworkModels: [],
  device: null,
  slave: null,
  deviceManager: null,
};

const getters = {
  commands(state) {
    let commands = {};
    state.devices.forEach((device) => {
      commands[device.id] = device.configurationSignaled.commands;
    });
    return commands;
  },
};

const actions = {
  init({commit, rootState}) {
    eventBus.$on("configuration", (device) => {
      commit("updateDevices", device);
      //commit('updateDevices',[device])
      commit("deviceActivityTriggered", {
        deviceId: device.id,
        gateway: device.attributes.gateway,
      });
    });
    eventBus.$on("telemetry", (telemetry) => {
      telemetry.forEach((data) => {
        commit("deviceActivityTriggered", {
          deviceId: data.id,
          gateway: data.gateway,
        });
      });
    });
    eventBus.$on("ai", (aiEvent) => {
      commit("deviceActivityTriggered", {
        deviceId: aiEvent.id,
        gateway: aiEvent.gateway,
      });
    });

    const httpInfo = rootState.metadata.backendApi.http.prod;

    const baseUrl = "https://" + httpInfo.host + "/" + httpInfo.basePath;
    const service = httpInfo.service;
    const region = httpInfo.region;

    const atrDeviceManager = new iotServicesSdk.device.assettracking.ATRDeviceManager(
      new URL(baseUrl),
      new iotServicesSdk.shared.auth.sigv4.SigV4Authorizer(service, region),
      region
    );
    commit("init", atrDeviceManager);
  },
  deinit({commit}) {
    return new Promise((resolve) => {
      commit("clearDevices");
      commit("clearFirmwares");
      resolve();
    });
  },

  registerDevice({commit, rootState}, device) {
    return new Promise(function(resolve, reject) {
      commit("startOperation", "Registration device", {root: true});

      // let deviceId = null
      // for(let i in device){
      //     if( i.includes("id--") && device[i] )
      //     {
      //         deviceId = device[i]
      //         break
      //     }
      // }
      // const newDevice = new iotServicesSdk.device.assettracking.ATRNewDevice(deviceId, device.label, device.technology, device.deviceProfile, device.certificate, device.apiKey);

      const newDevice = new iotServicesSdk.device.assettracking.ATRNewDevice(
        device.device_id,
        device.label,
        device.technology,
        device.device_profile,
        device.certificate,
        device.api_key,
        device.manual_provisioning
      );
      switch (newDevice.connectivity) {
        case iotServicesSdk.shared.types.DeviceConnectivity.LORA_TTN:
          newDevice.additionalParams = new iotServicesSdk.device.assettracking.LoRaTTNAdditionalParams(
            device.device_eui,
            device.lora_wan_version,
            device.lora_wan_phy_version,
            device.frequency_plan_id
          );
          break;
        case iotServicesSdk.shared.types.DeviceConnectivity.POLARIS:
          newDevice.additionalParams = new iotServicesSdk.device.assettracking.PolarisAdditionalParams(
            device.device_mac,
            device.device_eui,
            device.lora_wan_version,
            device.lora_wan_phy_version,
            device.frequency_plan_id
          );
          if (
            device.network_provider === "machineq" ||
            device.network_provider === "actility" ||
            device.network_provider === "loriot"
          ) {
            newDevice.id = device.device_eui.replace("-", "").toUpperCase();
          }
          break;
        case iotServicesSdk.shared.types.DeviceConnectivity.ASTRA:
          newDevice.additionalParams = new iotServicesSdk.device.assettracking.PolarisAdditionalParams(
            device.device_mac,
            device.device_eui,
            device.lora_wan_version,
            device.lora_wan_phy_version,
            device.frequency_plan_id
          );
          if (
            device.network_provider === "machineq" ||
            device.network_provider === "actility" ||
            device.network_provider === "loriot"
          ) {
            newDevice.id = device.device_eui.replace("-", "").toUpperCase();
          }
          break;
        case iotServicesSdk.shared.types.DeviceConnectivity.STEVALHARVEST1:
          const deviceprofile = rootState.deviceProfiles.deviceProfiles.find(
            (dp) => dp.id === device.device_profile
          );
          newDevice.additionalParams = new iotServicesSdk.device.assettracking.PolarisAdditionalParams(
            deviceprofile.context.region,
            device.device_eui,
            device.lora_wan_version,
            device.lora_wan_phy_version,
            device.frequency_plan_id
          );
          if (
            device.network_provider === "machineq" ||
            device.network_provider === "actility" ||
            device.network_provider === "loriot"
          ) {
            newDevice.id = device.device_eui.replace("-", "").toUpperCase();
          }
          break;
      }

      state.deviceManager
        .createDevice(newDevice, rootState.authentication.credentials)
        // rootState.serviceModule.deviceManager.RegisterDevice(device)
        .then((data) => {
          commit("stopOperation", null, {root: true});
          commit(
            "successLastOperationPerformed",
            "Registration success. Please reload your list of devices",
            {root: true}
          );
          if (data) {
            data = {
              name: device.device_id,
              credentials: data,
              isAvailable: true,
            };
          }
          resolve(data);
        })
        .catch((err) => {
          commit("stopOperation", null, {root: true});
          commit(
            "errorLastOperationPerformed",
            "Registration failed" + (err.data ? ": " + err.data.msg : err),
            {root: true}
          );
          commit(
            "errorLastOperationPerformed",
            "Registration failed" + (err ? ": " + err : ""),
            {root: true}
          );
          reject(err);
        });
    });
  },

  async fetchDevices({commit, rootState}, device) {
    return new Promise((resolve, reject) => {
      commit("startOperation", "Retrieving devices", {root: true});
      // rootState
      //     .serviceModule
      //     .deviceManager
      //     .ListDevices((device)?device.id:undefined)

      state.deviceManager
        .getDevices(rootState.authentication.credentials)
        .then((devices) => {
          device
            ? commit("updateDevices", devices)
            : commit("forceUpdateDevices", devices);
          commit("stopOperation", null, {root: true});
          commit("successLastOperationPerformed", "Devices retrieved", {
            root: true,
          });
          resolve();
        })
        .catch((err) => {
          commit("stopOperation", null, {root: true});
          commit("errorLastOperationPerformed", "Retrieving devices failed", {
            root: true,
          });
          reject(err);
        });
    });
  },

  updateConfigurationDevice({commit, rootState}, configurationObj) {
    return new Promise(function(resolve, reject) {
      commit("startOperation", "Updating device configuration", {root: true});
      rootState.serviceModule.deviceManager
        .UpdateConfiguration(
          configurationObj.deviceId,
          configurationObj.sharedWith
        )
        .then(() => {
          commit("stopOperation", null, {root: true});
          commit("successLastOperationPerformed", "Updating success", {
            root: true,
          });
          resolve();
        })
        .catch((err) => {
          commit("stopOperation", null, {root: true});
          commit("errorLastOperationPerformed", "Updating failed", {
            root: true,
          });
          reject(err);
        });
    });
  },

  deleteDevice({commit, rootState}, device) {
    return new Promise((resolve, reject) => {
      commit("startOperation", "Deleting device from cloud", {root: true});
      state.deviceManager
        .deleteDevice(device.id, rootState.authentication.credentials)
        // rootState.serviceModule.deviceManager.DeleteDevice(device.id,device.attributes.gateway)
        .then(() => {
          commit("stopOperation", null, {root: true});
          commit("successLastOperationPerformed", "Deleting success", {
            root: true,
          });

          commit("clearDevices", device);
          resolve();
        })
        .catch((err) => {
          commit("stopOperation", null, {root: true});
          commit("errorLastOperationPerformed", "Deleting failed", {
            root: true,
          });
          reject(err);
        });
    });
  },

  createPerimeter({commit, rootState}, perimeter) {
    return new Promise(function(resolve, reject) {
      commit("startOperation", "Registration of new perimeter", {root: true});
      rootState.serviceModule.deviceManager
        .CreatePerimeter(perimeter)
        .then((data) => {
          commit("stopOperation", null, {root: true});
          commit(
            "successLastOperationPerformed",
            "Registration of new perimeter succeeded.",
            {root: true}
          );
          resolve(data);
        })
        .catch((err) => {
          commit("stopOperation", null, {root: true});
          commit(
            "errorLastOperationPerformed",
            "Registration failed" + (err ? ": " + err : ""),
            {root: true}
          );
          reject(err);
        });
    });
  },

  fetchPerimeters({commit, rootState}, devices) {
    return new Promise(function(resolve, reject) {
      commit("startOperation", "Fetch perimeters", {root: true});
      rootState.serviceModule.deviceManager
        .FetchPerimeters(devices)
        .then((data) => {
          commit("stopOperation", null, {root: true});
          commit(
            "successLastOperationPerformed",
            "Fetch perimeters succeeded.",
            {root: true}
          );
          commit("updatePerimeters", data);
          resolve(data);
        })
        .catch((err) => {
          commit("stopOperation", null, {root: true});
          commit(
            "errorLastOperationPerformed",
            "Fetch perimeters failed" + (err ? ": " + err : ""),
            {root: true}
          );
          reject(err);
        });
    });
  },
};

const mutations = {
  init(state, deviceManager) {
    state.deviceManager = deviceManager;
  },

  setMetadata(state, metadata) {
    state.metadata = metadata;
  },

  forceUpdateDevices(state, devices) {
    state.devices = devices.sort((a, b) => a.id.localeCompare(b.id));
  },

  updateDevices(state, arg) {
    if (arg instanceof Array)
      state.devices = state.devices
        .filter(
          (device) =>
            arg.find((newDevice) => device.id == newDevice.id) == undefined
        )
        .concat(arg)
        .sort((a, b) => a.id.localeCompare(b.id));
    else {
      if (arg) {
        let device = state.devices.find((device) => device.id == arg.id);
        if (!device) return;
        //device.mergeDeep(patchDevice)
        device.rawLastGeolocation = arg.configurationSignaled.data.geolocation
          ? arg.configurationSignaled.data.geolocation
          : device.rawLastGeolocation;
        device.rawLastTelemetry = arg.configurationSignaled.data.telemetry
          ? arg.configurationSignaled.data.telemetry
          : device.rawLastTelemetry;
        device.rawLastEvents = arg.configurationSignaled.data.events
          ? arg.configurationSignaled.data.events
          : device.rawLastEvents;
      }
    }
  },

  updatePerimeters(state, arg) {
    state.perimeters = arg;
  },

  clearDevices(state, removedDevice) {
    if (removedDevice)
      state.devices = state.devices.filter(
        (device) =>
          !(
            removedDevice.id == device.id &&
            removedDevice.attributes.gateway == device.attributes.gateway
          )
      );
    else state.devices = [];
  },
  updateFirmwares(state, arg) {
    if (arg instanceof Array) {
      state.firmwares = arg.filter((firmware) => !firmware.type);
      state.neuralNetworkFirmwares = arg.filter(
        (firmware) => firmware.type == "neural"
      );
      state.neuralNetworkModels = arg.filter(
        (firmware) => firmware.type == "model"
      );
    }
  },
  clearFirmwares(state, arg) {
    if (arg instanceof Array) {
      state.firmwares = state.firmwares.filter((firmware) =>
        arg.find(
          (deletedFirmware) =>
            deletedFirmware.name == firmware.name &&
            firmware.type == deletedFirmware.type
        )
          ? false
          : true
      );
      state.neuralNetworkFirmwares = state.neuralNetworkFirmwares.filter(
        (firmware) =>
          arg.find(
            (deletedFirmware) =>
              deletedFirmware.name == firmware.name &&
              firmware.type == deletedFirmware.type
          )
            ? false
            : true
      );
    } else {
      state.firmwares = [];
      state.neuralNetworkFirmwares = [];
    }
  },

  selectDevice(state, deviceObj) {
    if (deviceObj) {
      let device = deviceObj.device;
      let index = deviceObj.index;

      if (index < state.device.length) {
        state.device[index] = device;
        state.device = state.device.filter(() => true);
      } else state.device.push(device);
    } else state.device = [];
  },
  unselectDevice(state, deviceObj) {
    state.device = state.device.filter(
      (device) => state.device[deviceObj.index].id != device.id
    );
  },
  deviceActivityTriggered(state, activityObj) {
    let deviceSelected = state.devices.find(
      (device) => device.id == activityObj.deviceId
    );

    if (deviceSelected) {
      Vue.set(deviceSelected, "lastActivity", new Date().getTime());
    }
  },
};

export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  namespaced: true,
};
